<template>
  <div class="insights-main">
    <el-row>
      <el-col :span="24">
        <organization-breadcrumb :items="['Insights']" />
      </el-col>
    </el-row>
    <div class="insights-body">
      <el-row :gutter="32" class="info-boxes" type="flex" id="overview-information">
        <el-col>
          <section class="elsa-section boxes-group-header">
            <h2>Insights</h2>
          </section>
        </el-col>
        <el-col>
          <img src="@/assets/images/insights-full.png" alt="insights" class="insights-main-image" />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import OrganizationBreadcrumb from "@/components/common/OrganizationBreadcrumb";

export default {
    components: {
      OrganizationBreadcrumb,
    },
    props: ["organizationId"],
    computed: {},
  };
</script>

<style lang="scss" scoped>
  .insights-main {
    width: 100%;

    .insights-body {
      text-align: center;
      padding: 40px 40px 0px;

      .boxes-group-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-bottom: 0px;

        h2 {
          font-weight: 700;
          font-size: 32px;
          line-height: 48px;
          margin-bottom: 25px;
        }
      }
      
      .insights-main-image {
        width: 100%;
        height: auto;
      }
    }
  }
</style>
